import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, UntypedFormArray, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { ApplicationInfoDto, CustomerContactListItemDto, DamageDisposition, EnumViewModel, GoodsInCondition, GoodsInFileDto, GoodsInLineItemDto, GoodsInLineItemFileDto, GoodsInReceiptDto, GoodsInStatus, PartLocationDto, PartReceiptCondition, PartReceiptQaStatus, PartResponse, PurchaseOrderDto, PurchaseOrderPartItemDto, PurchaseOrderStatus, TeamRole, UserDto } from "app/api/models";
import { EmployeeService, GoodsInService, PartService, PurchaseOrderService, SettingsService, SupplierService } from "app/api/services";
import { sortOnProperty, sumList } from "app/app.component";
import { TimeUtil } from "app/core/utils/time-utils";
import { UploadFilePopupComponent } from "app/views/admin/installation/documentations/upload-file-popup/upload-file-popup.component";
import { isNumber } from "lodash";
import { PartLocationQrScanDialogComponent } from "../../bin-qr-scan-dialog/bin-qr-scan-dialog.component";
import { AppAuthService } from "app/api/services/cookie-jwt-auth/app-auth.service";
import { AddItemDialogComponent } from "app/core/components/add-item-dialog/add-item-dialog.component";
import jsPDF from "jspdf";
import { AppLoaderService } from "app/core/services/app-loader/app-loader.service";
import { PurchaseOrderPreviewComponent } from "../../../purchase-orders/purchase-order-builder/purchase-order-preview/purchase-order-preview.component";

@Component({
    selector       : 'goods-in-dialog',
    templateUrl    : './goods-in-dialog.component.html',
    styleUrls      : ['./goods-in-dialog.component.scss'],
})
export class GoodsInDialogComponent implements OnInit
{
  @ViewChild("purchaseOrderPreview3") purchaseOrderPreview: PurchaseOrderPreviewComponent;
  
    public form: FormGroup;
    public receiptId: number;
    public receipt: GoodsInReceiptDto;
    public isCount: boolean;
    public isComplete: boolean;
    public isView: boolean;

    public isPartial: boolean;

    //goods in general images
    fileInfos: GoodsInFileDto[] = [];
    files: File[] = [];
    urls: SafeUrl[] = [];
    private queuedImages: any[] = [];

    //damage imges
    damageFileInfos: GoodsInLineItemFileDto[] = [];
    damageFiles: File[] = [];
    damageUrls: SafeUrl[] = [];


    public purchaseOrders: PurchaseOrderDto[] = [];
    public parts: PartResponse[] = [];
    public locations: PartLocationDto[] = [];
    public users: UserDto[] = [];
    public appInfo: ApplicationInfoDto;

    public print_contact: CustomerContactListItemDto = {};
    public print_partItems: PurchaseOrderPartItemDto[] = [];
    public print_po: PurchaseOrderDto = {};

    public conditions = Object.values(PartReceiptCondition).filter(x => isNumber(x)).map(x => <EnumViewModel> {name: this.getConditionName(+x), value: <PartReceiptCondition>x});
    public qaStatuses = Object.values(PartReceiptQaStatus).filter(x => isNumber(x)).map(x => <EnumViewModel> {name: this.getQaStatusName(+x), value: <PartReceiptQaStatus>x});
    
    public damageDispositions = Object.values(DamageDisposition).filter(x => isNumber(x)).map(x => <EnumViewModel> {name: this.getDamageDispositionName(+x), value: <DamageDisposition>x});
    
    public PurchaseOrderStatus = PurchaseOrderStatus;

    public partialDeliveryNumbers: EnumViewModel[] = [
        { value: 0, name: "1st Delivery (more to follow)" },
        { value: 1, name: "2nd Delivery (more to follow)" },
        { value: 2, name: "3rd Delivery (more to follow)" },
        { value: 3, name: "4th Delivery (more to follow)" },
        { value: 4, name: "Final Delivery" },
    ];

    constructor(
        public dialogRef: MatDialogRef<GoodsInDialogComponent>,
        private partService: PartService,
        private purchaseOrderService: PurchaseOrderService,
        private employeeService: EmployeeService,
        private goodsInService: GoodsInService,
        private settingsService: SettingsService,
        private supplierService: SupplierService,
        private _formBuilder: FormBuilder,
        private cdr: ChangeDetectorRef,
        private datePipe: DatePipe,
        private dialog: MatDialog,
        private sanitizer: DomSanitizer,
        private _fuseConfirmationService: FuseConfirmationService,
        private appAuth: AppAuthService,
        private loader: AppLoaderService,
        @Inject(MAT_DIALOG_DATA) public data: {receiptId: number, isCount: boolean, isView: boolean, purchaseOrderId?: number}
    )
    {}

    async ngOnInit(): Promise<void>
    {
        this.receiptId = this.data.receiptId;
        this.isCount = this.receiptId && this.data.isCount;
        this.isView = this.receiptId && this.data.isView;
        var purchaseOrderId = this.data.purchaseOrderId;

        this.loadParts();
        this.loadLocations();
        this.loadUsers();
        this.loadAppInfo();
        await this.loadPurchaseOrders();

        if(this.receiptId) {
            this.loadFiles();
            this.goodsInService.apiGoodsInGetGoodsInGet$Json$Response({id: this.receiptId}).subscribe(res => {
                if(!res?.body?.data) return;
                this.receipt = res.body.data;
                this.isPartial = this.receipt.isPartial;
                this.isComplete = this.receipt.status >= GoodsInStatus.Completed;
                this.buildForm();
                this.loadDamageFiles();
            });
        }
        else {
            this.buildForm();
            // console.log("no grn, po id:", purchaseOrderId);
            if(purchaseOrderId) {
                this.form.controls['purchaseOrderId'].setValue(purchaseOrderId);
                this.poChanged(<any>{value: purchaseOrderId});
            }
        }
    }

    async loadPurchaseOrders() {
        var res = await this.purchaseOrderService.apiPurchaseOrderGetAllGet$Json$Response({isSupplier: true}).toPromise();
        if(!res?.body?.data) return;
        
        this.purchaseOrders = res.body.data;//.filter(x => !x.isDraft && x.status != PurchaseOrderStatus.Complete);
        this.cdr.detectChanges();
    }

    loadParts() {
        this.partService.apiPartPartsGet$Json$Response().subscribe(res => {
            if(!res?.body?.data) return;
            this.parts = res.body.data;
        });
    }

    loadLocations() {
        this.partService.apiPartLocationsGet$Json$Response().subscribe(res => {
            if(!res?.body?.data) return;
            this.locations = res.body.data;
        });
    }
    
    loadUsers() {
        this.employeeService.apiEmployeeSearchEmployeeUsersGet$Json$Response({archived: false}).subscribe(res => {
            if(!res?.body.data) return;

            //allow received by super admins and stores team
            this.users = sortOnProperty(res.body.data.filter(x => +x.dlmAccessLevel >= 4 || x.teamRole == +TeamRole.Stores), 'firstName');
        });
    }

    loadAppInfo() {
        this.settingsService.apiSettingsAppInfoGet$Json$Response().subscribe(res => {
            if(!res?.body?.data) return;
    
            this.appInfo = res.body.data;
        });
    }

    buildForm() {
        this.form = this._formBuilder.group({
            grnRef                  : [this.receipt?.grnRef             ?? '',          Validators.required],
            receiptDate             : [this.receipt?.receiptDate        ?? new Date(),  Validators.required],
            receiptTime             : [this.datePipe.transform(this.receipt?.receiptDate ?? new Date(), 'HH:mm'),   Validators.required],
            receivedUserId          : [this.receipt?.receivedUserId ?? this.appAuth.getUser()?.id ?? null,          Validators.required],
            deliveryRef             : [this.receipt?.deliveryRef        ?? ''],
            carrier                 : [this.receipt?.carrier            ?? ''],
            trackingNumber          : [this.receipt?.trackingNumber     ?? ''],
            purchaseOrderId         : [this.receipt?.purchaseOrderId    ?? null,       Validators.required],
            notes                   : [this.receipt?.notes              ?? ''],

            items                   : this._formBuilder.array([], this.itemsValidator),
        });
        this.form.controls['grnRef'].disable();
        
        if(!this.receipt?.grnRef)
            this.setNewRef();

        this.receipt?.lineItems?.forEach((item: GoodsInLineItemDto) => this.addLineItem(item));

        this.cdr.detectChanges();
    }
    

    setNewRef() {
        //gen new grn ref
        if(this.receipt?.goodsInReceiptId)
            this.goodsInService.apiGoodsInGetGrnRefPost$Json$Response({body: this.receipt}).subscribe(res => {
                if(!res?.body) return;
                this.form.controls['grnRef'].setValue(res.body.message);
            });
        else
            this.goodsInService.apiGoodsInGetNextGrnRefGet$Json$Response().subscribe(res => {
                if(!res?.body) return;
                this.form.controls['grnRef'].setValue(res.body.message);
            });
    }

    itemsValidator(control: FormArray): { [key: string]: boolean } | null {
        if (control.length < 1)
          return { 'noItems': true };
    
        return null;
    }

    get items(): FormArray {
        return this.form ? this.form?.get('items') as FormArray : null;
    }
    addLineItem(existingItem: GoodsInLineItemDto = null, poItem: PurchaseOrderPartItemDto = null) {
        this.items?.push(this.newItem(existingItem, poItem));
        this.cdr.detectChanges();
    }
    newItem(existingItem: GoodsInLineItemDto = null, poItem: PurchaseOrderPartItemDto = null): FormGroup {
        return this._formBuilder.group({
            goodsInLineItemId:          [ existingItem?.goodsInLineItemId ?? null ],
            purchaseOrderPartItemId:    [ existingItem?.purchaseOrderPartItemId ?? poItem?.purchaseOrderItemId ?? null],

            delivered:  [ existingItem?.delivered ?? poItem?.quantity,        [(c) => this.itemCountValidator(c, !this.isCount && this.isPartial), Validators.min(0)]],
            received:   [ existingItem?.received ?? 0 /*poItem?.quantity*/,         [(c) => this.itemCountValidator(c, this.isCount), Validators.min(0)]],
            damaged:    [ existingItem?.damaged ?? 0,                               [(c) => this.itemCountValidator(c, this.isCount), Validators.min(0)]],
            condition:  [ existingItem?.condition ?? PartReceiptCondition.Good,     [(c) => this.itemCountValidator(c, !this.isCount)]],
            qaStatus:   [ existingItem?.qaStatus ?? PartReceiptQaStatus.NotRequired],
            locationId: [ existingItem?.locationId ?? null,                         [(c) => this.itemCountValidator(c, this.isCount)]],
            lineNotes:  [ existingItem?.lineNotes ?? ''],

            expectedRemainingDeliveryDate:  [ existingItem?.expectedRemainingDeliveryDate ?? null],
            partialReason:                  [ existingItem?.partialReason ?? null],
            partialDeliveryIndex:           [ existingItem?.partialDeliveryIndex ?? 0],

            quarantineLocationId:           [ existingItem?.quarantineLocationId ?? null,   [(c) => this.requiredIfDamageValidator(c)]],
            damageDisposition:              [ existingItem?.damageDisposition ?? null,      [(c) => this.requiredIfDamageValidator(c)]],
            damageDescription:              [ existingItem?.damageDescription ?? null,      [(c) => this.requiredIfDamageValidator(c)]],
        });
    }
    deleteItem(index: number) {
        this.items?.removeAt(index);
        this.cdr.detectChanges();
    }

    itemCountValidator(control: FormArray, required: boolean): { [key: string]: boolean } | null {
        if (required && !isNumber(control.value))
          return { required: true };
    
        return null;
    }
    
    requiredIfDamageValidator(control: FormArray): { [key: string]: boolean } | null {
        const parent = control.parent;
        if (!parent) return null;

        const damage = parent.get('damaged')?.value || 0;

        return damage > 0 && control.value == null ? { required: true } : null;
    }

    getPo() {
        var poId = this.form?.controls['purchaseOrderId']?.value;
        if(!poId) return null;
        return this.purchaseOrders?.find(x => x.purchaseOrderId == poId) ?? null;
    }
    getPoItem(itemControl: FormGroup) {
        var poId = this.form?.controls['purchaseOrderId']?.value;
        var poItemId = itemControl.controls['purchaseOrderPartItemId']?.value;
        if(!poId || !poItemId) return null;

        return this.purchaseOrders.find(x => x.purchaseOrderId == poId)?.purchaseOrderPartItems.find(x => x.purchaseOrderItemId == poItemId) ?? null;
    }
    getPoItemPart(itemControl: FormGroup) {
        var item = this.getPoItem(itemControl);
        if(!item) return null;

        return this.parts?.find(x => x.id == item.partId) ?? null;
    }

    getUserName(userId: number) {
        var user = this.users?.find(x => x.id == userId);
        return user ? `${user.firstName} ${user.lastName}` : '';
    }

    getPartialDiscrepency = (itemControl: FormGroup) => !this.isPartial ? 0 : this.getPoItem(itemControl)?.quantity - itemControl.controls['delivered'].value;
    hasPartialDiscrepency = (itemControl: FormGroup) => this.getPartialDiscrepency(itemControl) > 0;

    getExpectedQuantity = (itemControl: FormGroup) => !this.hasPartialDiscrepency(itemControl) ? (this.getPoItem(itemControl)?.quantity ?? 0) : itemControl.controls['delivered'].value;
    getCountDiscrepency = (itemControl: FormGroup) => (this.getExpectedQuantity(itemControl) - itemControl.controls['received'].value);
    hasCountDiscrepency = (itemControl: FormGroup) => this.getCountDiscrepency(itemControl) != 0;

    hasDamage = (itemControl: FormGroup) => itemControl.controls['damaged'].value > 0;
    
    getLocationCode = (itemControl: FormGroup, isQuarantine: boolean = false) => this.locations?.find(x => x.partLocationId == itemControl.controls[isQuarantine ? 'quarantineLocationId' : 'locationId'].value)?.code;

    getLineItemId = (itemControl: FormGroup) => itemControl.controls['goodsInLineItemId'].value;

    countImages = (itemControl: FormGroup) => this.damageFileInfos?.filter(x => x.goodsInLineItemId == this.getLineItemId(itemControl))?.length;
    hasImages = (itemControl: FormGroup) => this.damageFileInfos?.some(x => x.goodsInLineItemId == this.getLineItemId(itemControl));

    anyMissingDamageImages = () => this.items?.controls?.some((x: FormGroup) => this.hasDamage(x) && !this.hasImages(x));
    anyCountDiscrepencies = () => this.items?.controls?.some((x: FormGroup) => this.hasCountDiscrepency(x));
    

    poChanged(event: MatSelectChange) {
        var po = this.purchaseOrders.find(x => x.purchaseOrderId == event.value);

        //replace line items
        this.items.clear();
        po?.purchaseOrderPartItems.forEach(item => this.addLineItem(null, item));
    }

    setPartial(isPartial: boolean) {
        this.isPartial = isPartial;

        //if full delivery, reset all the delivered qty fields and partial info
        if(this.isPartial)
            this.items?.controls?.forEach((itemControl: FormGroup) => itemControl.controls['delivered'].setValue(0));
        else
            this.items?.controls?.forEach((itemControl: FormGroup) => {
                itemControl.controls['expectedRemainingDeliveryDate'].setValue(null);
                itemControl.controls['partialReason'].setValue(null);
                itemControl.controls['partialDeliveryIndex'].setValue(0);

                var poItem = this.getPoItem(itemControl);
                if(!poItem) return;
                itemControl.controls['delivered'].setValue(poItem.quantity);
            });
    }
    
    openLocationScanner(itemControl: FormGroup, isQuarantine: boolean = false) {
        var dialog = this.dialog.open(PartLocationQrScanDialogComponent);

        dialog.afterClosed().subscribe((dialogRes) => {
            if (!dialogRes) return;

            var locationId = this.locations.find(x => x.code == dialogRes)?.partLocationId;
            if(!locationId) return;

            itemControl.controls[isQuarantine ? 'quarantineLocationId' : 'locationId'].setValue(locationId);
        });
    }

    buildModel() {
        var formValue = this.form.value;
        var receipt = this.form.value as GoodsInReceiptDto;
        receipt.goodsInReceiptId = this.receiptId ?? null;
        receipt.grnRef = this.form.controls['grnRef'].value ?? ''; //needs specifically pulling it due to disabled form control

        var receiptDate = TimeUtil.setTo1amUTC(new Date(formValue.receiptDate));
        var time = formValue.receiptTime.split(':');
        receiptDate.setHours(time[0], time[1]);

        receipt.receiptDate = receiptDate.toISOString();
        receipt.isPartial = this.isPartial;
        
        // items
        var lineItems = [];
        this.items?.controls?.forEach((itemControl: FormGroup) => {
          var item: GoodsInLineItemDto = itemControl.value;
          item.goodsInReceiptId = this.receiptId ?? 0;
    
          lineItems?.push(item);
        });
        receipt.lineItems = lineItems;
        receipt['items'] = null;

        //calculate statuses
        receipt.status = this.isCount ? this.anyCountDiscrepencies() ? GoodsInStatus.ShortDelivery : GoodsInStatus.Completed : GoodsInStatus.Parked;

        if(!this.isCount)
            receipt.condition = GoodsInCondition.AwaitingCount;
        else {
            //get worst condition from line items
            var conditions = receipt.lineItems.map(x => +x.condition + 1);
            var max = Math.max(0, ...conditions);
            receipt.condition = <GoodsInCondition>max;

            //todo figure out logic to override user's damage appraisal
            // if(receipt.lineItems.filter(x => x.damaged > 0).length > 0)
            //     receipt.condition = GoodsInCondition.Damaged
        }

        return receipt;
    }
    
    save(openCount: boolean = false) {
        var wasCompleted = this.receipt?.status == GoodsInStatus.Completed;
        var form = this.buildModel();
        var isNewlyCompleted = !wasCompleted && form.status == GoodsInStatus.Completed;

        this.dialogRef.close({
            form: form,
            queuedImages: this.queuedImages,
            openCount: openCount,
            isNewlyCompleted: isNewlyCompleted,
        });
    }

    close() {
        this.dialogRef.close(null);
    }

    emailSupplierShortDelivery() {
        this.askToSendEmail();
    }

    askToSendEmail(navigate: boolean = true) {
        const confirmation = this._fuseConfirmationService.open({
          title  : 'Send Email',
          message: `Would you like to email the supplier about the missing items?`,
          actions: {
              confirm: {
                  label: 'Yes',
              },
              cancel: {
                label: 'No',
              }
          },
        });
    
        confirmation.afterClosed().subscribe((result) => {
          if (result === 'confirmed') {

            //get the PO details, generate the PDF...
            var po = this.getPo();
            if(!po) return;

            var poNumber = po.salesOrderRef ?? 'ORD-NEX-' + po.purchaseOrderId.toString().padStart(4, '0');
            //get supplier
            this.supplierService.apiSupplierSearchAllGet$Json$Response({searchTerm: po.supplier}).subscribe(res => {
                var supplier = res?.body?.data?.length ? res.body.data[0] : null;
                
                var dialog = this.dialog.open(AddItemDialogComponent, {
                    data: {
                        title: "Send Email",
                        items: [
                            {name: 'to', initialValue: supplier?.mainContact?.email ?? "", mandatory: true},
                            {name: 'subject', initialValue: `Short Delivery - PO ${poNumber}`, mandatory: true},
                            {name: 'body', type: 'textarea', mandatory: true, initialValue:
                                `Dear ${supplier?.mainContact?.name ?? po.supplier},\n\n` +
                                `We have received delivery against Purchase Order ${poNumber}, however some items were missing from the shipment.\nPlease see the details below.\n\n` +
                                
                                `Missing Items:\n` +
                                this.items?.controls?.filter((x: FormGroup) => this.hasCountDiscrepency(x)).map((itemControl: FormGroup) =>
                                    `${this.getPoItemPart(itemControl).number} - missing x${this.getCountDiscrepency(itemControl)}`
                                ).join('\n') + `\n` +
                                "The purchase order is attached for reference.\n\n" +

                                "Could you please confirm whether the missing items will be shipped separately or if a credit note will be issued.\n\n" +
                                `Delivery Details:\n` +
                                `PO Number: ${poNumber}\n` +
                                `Delivery Note: ${this.receipt?.deliveryRef || '-'}\n` +
                                `Date Received: ${this.datePipe.transform(this.receipt?.receiptDate, 'dd/MM/yyyy')}\n\n` +

                                "We would appreciate confirmation of how this will be resolved.\n\n" +
                                "Best regards,\n" +
                                this.appInfo.companyName
                            },
                        ],
                        overrideSaveText: 'Send',
                        overrideWidth: 65,
                    }
                });

                dialog.afterClosed().subscribe((dialogRes) => {
                    if (!dialogRes) return;
                    
                    this.loader.open();
                    this.print_po = po;
                    this.print_partItems = po.purchaseOrderPartItems;
                    this.print_contact = supplier?.mainContact ?? {name: po.supplier};

                    this.showPrintPreview();
                    this.purchaseOrderPreview.generatePdf().then(PDF => {
                        this.hidePrintPreview();
                        this.loader.close();
                        this.sendPurchaseOrderEmail(PDF, dialogRes.to, dialogRes.subject, dialogRes.body, po);

                        if(navigate)
                            this.close();
                    });
                });

            });
          }
        });
    }
    
    sendPurchaseOrderEmail(PDF: jsPDF, to: string, subject: string, body: string, po: PurchaseOrderDto) {
        var blob = PDF.output('blob');
    
        var request = {
          purchaseOrderId: po.purchaseOrderId,
          filename: this.purchaseOrderPreview.GetPOTitle(),
          emailTo: to,
          emailSubject: subject,
          emailBody: body,
          ccProcurement: true,
          body: {
            formFile: blob
          }
        };
        
        this.purchaseOrderService.apiPurchaseOrderSendPurchaseOrderEmailPost$Json$Response(request).subscribe(res => {
          if(!res?.body?.data) return;
    
        });
    }

    private showPrintPreview() {
        var doc = document.getElementById('print-preview3');
        doc.style.display = 'block';
    }
    private hidePrintPreview() {
        var doc = document.getElementById('print-preview3');
        if(!doc) return;
        doc.style.display = 'none';
    }    

    getConditionName(condition: PartReceiptCondition) {
        switch(condition) {
            case PartReceiptCondition.PartialDamage: return 'Partial Damage';
            default: return PartReceiptCondition[condition];
        }
    }
    getQaStatusName(status: PartReceiptQaStatus) {
        switch(status) {
            case PartReceiptQaStatus.NotRequired: return 'Not Required';
            default: return PartReceiptQaStatus[status];
        }
    }

    getDamageDispositionName(disposition: DamageDisposition) {
        switch(disposition) {
            case DamageDisposition.AsIs: return 'Use As-Is (Minor cosmetic damage)';
            case DamageDisposition.Repair: return 'Repair/Rework (Can be fixed)';
            case DamageDisposition.Rma: return 'Return to Supplier (RMA)';
            case DamageDisposition.Scrap: return 'Scrap (Beyond repair)';
            default: return DamageDisposition[disposition];
        }
    }

    getTotalItemCount() {
        if(!this.receipt?.lineItems) return 0;
        return sumList(this.receipt.lineItems.map(x => x.received));
    }
    getTotalDamageCount() {
        if(!this.receipt?.lineItems) return 0;
        return sumList(this.receipt.lineItems.map(x => x.damaged));
    }
    getTotalDiscrepencyCount() {
        if(!this.receipt?.lineItems) return 0;
        return sumList(this.items?.controls?.map(this.getCountDiscrepency) ?? []);
    }

    // Files
    loadFiles() {
        if(!this.receiptId) return;

        this.urls = [];
        this.files = [];

        this.goodsInService.apiGoodsInGetFilesGet$Json({ goodsInReceiptId: this.receiptId }).subscribe(async res => {
            if(!res?.data) return;

            this.fileInfos = res.data;

            for(var grnFile of this.fileInfos) {
                var resImg = await this.goodsInService.apiGoodsInDownloadFileFileIdGet({ fileId: grnFile.goodsInFileId }).toPromise();
                if(!resImg) return;

                const blob = new Blob([resImg], { type: 'application/octet-stream' });
                const file = new File([blob], grnFile.name);
                const blobUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));

                this.files.push(file);
                this.urls.push(blobUrl);
            }

            this.cdr.detectChanges();
        });
    }

    async openFileUpload(){
        var dialog = this.dialog.open(UploadFilePopupComponent, {autoFocus: false});
  
        dialog.afterClosed().subscribe((dialogRes) => {
            if (!dialogRes) return;
    
            if(this.receiptId)
                this.uploadImages(dialogRes);
            else
                this.queueImages(dialogRes);
        });    
    }
  
    async uploadImages(files: FileList) {
        if (!this.receiptId) return;
        
        var newFiles = Array.from(files);

        for(var file of newFiles) {
            var blob: Blob = file;
            var name: string = file.name;

            await this.goodsInService.apiGoodsInUploadFileGoodsInReceiptIdPost$Json({ 
                goodsInReceiptId: this.receiptId, 
                filename: name, 
                body: { formFile: blob },
            }).toPromise();
        }

        this.loadFiles();
    }

    queueImages(files: FileList) {
        var newFiles = Array.from(files);

        newFiles.forEach(async (file) => {
            var blob: Blob = file;
            var name: string = file.name;

            const blobUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
            
            this.fileInfos.push({ name: name });
            this.files.push(file);
            this.urls.push(blobUrl);

            this.queuedImages.push({ 
                filename: name, 
                body: { formFile: blob },
            });
        });
    }

    deleteFile(index: number, event: any){
        event.stopPropagation();

        const file = this.fileInfos[index];

        // Open the confirmation dialog
        const confirmation = this._fuseConfirmationService.open({
            title  : "Delete File",
            message: 'Are you sure you want to delete this file?',
            actions: {
                confirm: {
                label: "Delete",
                },
            },
        });
   
       // Subscribe to the confirmation dialog closed action
       confirmation.afterClosed().subscribe((result) => {
         // If the confirm button pressed...
         if ( result === 'confirmed' )
         {
            if(this.receiptId)
                this.goodsInService.apiGoodsInDeleteFileFileIdDelete$Json$Response({ fileId: file?.goodsInFileId }).subscribe((res) => {
                        if(!res) return;

                        this.fileInfos = this.fileInfos.filter((_, i) => i != index);
                        this.files = this.files.filter((_, i) => i != index);
                        this.urls = this.urls.filter((_, i) => i != index);
                });
            else {
                this.fileInfos = this.fileInfos.filter((_, i) => i != index);
                this.files = this.files.filter((_, i) => i != index);
                this.urls = this.urls.filter((_, i) => i != index);
                this.queuedImages = this.queuedImages.filter((_, i) => i != index);
            }
         }
       });
    }

    downloadImage(i: number) {
        var file = this.files[i];
        var blob: Blob = file;

        // Download the blob
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name + (!file?.name.endsWith(file?.type) ? file?.type : '');
        link.click();
        window.URL.revokeObjectURL(url);
    }


    // Damage Files
    async loadDamageFiles() {
        if(!this.receiptId) return;

        this.damageUrls = [];
        this.damageFiles = [];
        this.damageFileInfos = [];

        for(var lineItem of this.receipt.lineItems) {
            var res = await this.goodsInService.apiGoodsInGetLineItemFilesGet$Json({ goodsInLineItemId: lineItem.goodsInLineItemId }).toPromise();
            if(!res?.data) return;

            this.damageFileInfos.push(...res.data);

            for(var itemFile of this.damageFileInfos) {
                var resImg = await this.goodsInService.apiGoodsInDownloadLineItemFileFileIdGet({ fileId: itemFile.goodsInLineItemFileId }).toPromise();
                if(!resImg) return;

                const blob = new Blob([resImg], { type: 'application/octet-stream' });
                const file = new File([blob], itemFile.name);
                const blobUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));

                this.damageFiles.push(file);
                this.damageUrls.push(blobUrl);
            }

            this.cdr.detectChanges();
        }
    }

    async openDamageFileUpload(itemControl: FormGroup){
        var lineItemId = this.getLineItemId(itemControl);
        if(!lineItemId) return;

        var dialog = this.dialog.open(UploadFilePopupComponent, {autoFocus: false});
  
        dialog.afterClosed().subscribe((dialogRes) => {
            if (!dialogRes) return;
    
            this.uploadDamageImages(dialogRes, lineItemId);
        });    
    }
  
    async uploadDamageImages(files: FileList, lineItemId: number) {
        if (!lineItemId) return;
        
        var newFiles = Array.from(files);

        for(var file of newFiles) {
            var blob: Blob = file;
            var name: string = file.name;

            await this.goodsInService.apiGoodsInUploadLineItemFileGoodsInLineItemIdPost$Json({ 
                goodsInLineItemId: lineItemId, 
                filename: name, 
                body: { formFile: blob },
            }).toPromise();
        }

        this.loadDamageFiles();
    }

    deleteDamageFile(index: number, event: any){
        event.stopPropagation();

        const file = this.damageFileInfos[index];

        // Open the confirmation dialog
        const confirmation = this._fuseConfirmationService.open({
            title  : "Delete File",
            message: 'Are you sure you want to delete this file?',
            actions: {
                confirm: {
                label: "Delete",
                },
            },
        });
   
       // Subscribe to the confirmation dialog closed action
       confirmation.afterClosed().subscribe((result) => {
         // If the confirm button pressed...
         if ( result === 'confirmed' )
         {
            this.goodsInService.apiGoodsInDeleteLineItemFileFileIdDelete$Json$Response({ fileId: file?.goodsInLineItemFileId }).subscribe((res) => {
                if(!res) return;

                this.damageFileInfos = this.damageFileInfos.filter((_, i) => i != index);
                this.damageFiles = this.damageFiles.filter((_, i) => i != index);
                this.damageUrls = this.damageUrls.filter((_, i) => i != index);
            });
         }
       });
    }

    downloadDamageImage(i: number) {
        var file = this.damageFiles[i];
        var blob: Blob = file;

        // Download the blob
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name + (!file?.name.endsWith(file?.type) ? file?.type : '');
        link.click();
        window.URL.revokeObjectURL(url);
    }

    getStatusName(status: GoodsInStatus) {
        switch(status) {
            case GoodsInStatus.PendingReview: return 'Pending Review';
            case GoodsInStatus.ShortDelivery: return 'Short Delivery';
            default: return GoodsInStatus[status];
        }
    }

    getStatusStyle(status: GoodsInStatus) {
        var styleString = 'width: fit-content; border-radius: 16px; padding: 4px 10px; background-color: ';

        switch(status) {
            case GoodsInStatus.Completed:
                return styleString + '#00d308; color: white;'; // green
            case GoodsInStatus.Parked:
                return styleString + '#ebe102;'; // yellow
            case GoodsInStatus.PendingReview:
                return styleString + '#f1982f; color: white;'; // Orange
            case GoodsInStatus.ShortDelivery:
                return styleString + '#fb1d1d; color: white;'; // red
            default:
                return '';
        }
    }
}
